export default {"src":"/_next/static/media/ski.04a994e6.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};